/* eslint-disable */
import { useMemo } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
import { Bar, Chart } from "react-chartjs-2";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

import SuiButton from "components/SuiButton";
import Icon from "@mui/material/Icon";
import { saveAs } from "file-saver";

// VerticalBarChart configurations
import configs from "./configs";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

import UILogo from "assets/images/logo-my.png";

import Watermark from "@uiw/react-watermark";
import downloadjs from "downloadjs";
import html2canvas from "html2canvas";

/* import zoomPlugin from "chartjs-plugin-zoom";

Chart.register(zoomPlugin); // REGISTER PLUGIN */

const handleCaptureClick = async () => {
  const canvas = await html2canvas(document.getElementById("stackD"));
  const dataURL = canvas.toDataURL("image/png");
  downloadjs(dataURL, "myslr_years_stats.png", "image/png");
};

function saveCanvas() {
  //save to png
  const canvasSave = document.getElementById("stackD");
  canvasSave.toBlob(function (blob) {
    saveAs(blob, "myslr_years_stats.png");
  });
}

function YearBarChart({ title, description, height, chart }) {
  const chartDatasets = chart.datasets.map((dataset) => ({
    ...dataset,
    weight: 6,
    borderWidth: 0,
    borderRadius: 4,
    backgroundColor: dataset.color,
    fill: false,
    maxBarThickness: 35,
  }));

  const { data, options } = configs(chart.labels, chartDatasets);

  const renderChart = (
    <SuiBox p={2}>
      {title || description ? (
        <SuiBox px={description ? 1 : 0} pt={description ? 1 : 0}>
          {title && (
            <SuiBox mb={1}>
              <SuiTypography variant="h6" textAlign="center">
                {title} {"      "}
                <SuiButton variant="button" buttonColor="dark" onClick={handleCaptureClick}>
                  PNG&nbsp;
                  <Icon className="">download</Icon>
                </SuiButton>
              </SuiTypography>
            </SuiBox>
          )}
          <SuiBox mb={2}>
            <SuiTypography variant="button" fontWeight="regular" textColor="text">
              {description}
            </SuiTypography>
          </SuiBox>
        </SuiBox>
      ) : null}
      {
        <div id="stackD">
          <Watermark content="MySLR ©">
            <SuiBox height={height}>
              <Bar data={data} options={options} />
            </SuiBox>
          </Watermark>
        </div>
      }
    </SuiBox>
  );

  return title || description ? <Card>{renderChart}</Card> : renderChart;
}

// Setting default values for the props of VerticalBarChart
YearBarChart.defaultProps = {
  title: "",
  description: "",
  height: "19.125rem",
};

// Typechecking props for the VerticalBarChart
YearBarChart.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  chart: PropTypes.objectOf(PropTypes.array).isRequired,
};

export default YearBarChart;
